import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import {
  isPeriodMarketplaceLoan,
  getLoanAcceptPrice,
  getLoanCardTitle,
  getLoanPeriodHours,
  getLoanPeriodsRemaining
} from '../../../utils/loanDisplayUtils';

const CompanyLoanCard = ({ loan, onEditDetails, onRemove }) => {
  const isPeriod = isPeriodMarketplaceLoan(loan);
  const periodHours = getLoanPeriodHours(loan);
  const pricePerPeriod = parseFloat(loan.price_per_period) || parseFloat(loan.total_price) || 0;
  const pricePerGW = parseFloat(loan.price_per_gw) || 0;
  const acceptPrice = getLoanAcceptPrice(loan);

  return (
    <div className="bg-gray-800 rounded-lg p-6 border border-yellow-500/50 hover:border-yellow-500 transition-all relative">
      {loan.availableCount !== undefined && loan.availableCount > 1 && (
        <div className="absolute top-2 right-2 z-10 bg-yellow-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-sm shadow-lg border-2 border-white/50">
          {loan.availableCount}
        </div>
      )}
      <div className="flex items-center justify-between mb-4">
        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-yellow-600/30 text-yellow-300 border border-yellow-500/50">
          🔄 {isPeriod ? 'Period Loan' : 'Loan'}
        </span>
      </div>
      
      <h3 className="text-xl font-bold text-white mb-3">
        {getLoanCardTitle(loan)}
      </h3>
      
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Position:</span>
          <span className="text-white font-semibold">{loan.player?.position || 'N/A'}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Rarity:</span>
          <span className="text-white font-semibold">
            ⭐ {loan.rarity?.display_name || loan.rarity?.name || 'N/A'}
          </span>
        </div>
        <div className="border-t border-gray-700 pt-2 mt-2 space-y-2">
          {isPeriod ? (
            <>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Price per period ({periodHours}h):</span>
                <span className="text-yellow-400 font-semibold">{pricePerPeriod.toFixed(2)} DIOS</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Periods offered:</span>
                <span className="text-white font-semibold">{loan.period_count ?? '—'}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Periods remaining:</span>
                <span className="text-white font-semibold">{getLoanPeriodsRemaining(loan)}</span>
              </div>
              <div className="flex items-center justify-between pt-2 border-t border-gray-700">
                <span className="text-gray-400 text-sm">Cost per period:</span>
                <span className="text-yellow-400 font-bold text-lg">{acceptPrice.toFixed(2)} DIOS</span>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Price per Gameweek:</span>
                <span className="text-yellow-400 font-semibold">{pricePerGW.toFixed(2)} DIOS</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Duration:</span>
                <span className="text-white font-semibold">{loan.duration_gw} Gameweeks</span>
              </div>
              <div className="flex items-center justify-between pt-2 border-t border-gray-700">
                <span className="text-gray-400 text-sm">Total Cost:</span>
                <span className="text-yellow-400 font-bold text-lg">{acceptPrice.toFixed(2)} DIOS</span>
              </div>
            </>
          )}
          {loan.borrower && (
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-400">Borrower:</span>
              <span className="text-blue-400 font-semibold">{loan.borrower.username}</span>
            </div>
          )}
        </div>
      </div>
      
      <div className="flex space-x-2 mt-4 pt-4 border-t border-gray-700">
        <button
          onClick={() => onEditDetails(loan)}
          className="flex-1 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg transition-all flex items-center justify-center"
        >
          <Edit className="w-4 h-4 mr-1" />
          Edit Details
        </button>
        <button
          onClick={() => onRemove(loan.id)}
          className="px-3 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-lg transition-all flex items-center justify-center"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default CompanyLoanCard;
